import { render, staticRenderFns } from "./NewStudent.vue?vue&type=template&id=46a85e44&scoped=true&"
import script from "./NewStudent.vue?vue&type=script&lang=js&"
export * from "./NewStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a85e44",
  null
  
)

export default component.exports